module.exports = __webpack_public_path__ + "front/img/z2.e9f91837.jpg";